import { Component, OnInit } from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcTranslation} from 'exc-core';
import {ExcTab} from 'exc-tab';
import {AuditDetailsComponent} from '../../audit-details/audit-details.component';
import {SearchSlimData} from '../../search-slim/search-slim.component';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styles: []
})
export class CalendarComponent extends ExcTranslation implements OnInit {

  isLoading = false;
  WeekMode = false;
  IsoWeek = 1;
  WeeksOfYear = 1;
  WeekList: any[] = [];
  Calendar: any[] = [];
  SmallMode = true;
  Month = ((new Date()).getMonth() + 1);
  Year = ((new Date()).getFullYear());
  SearchValue = '';
  YearOptions: any[] = [];
  MonthOptions: any[] = [];
  WeekOptions: any[] = [];
  searchTimeout: any = null;

  constructor(private excRest: ExcRestService, private excDss: DefaultSettingsService) {
    super();
    const _self = this;
    _self.IsoWeek = _self.getWeek(new Date());
    _self.WeeksOfYear = _self.getWeeksOfYear(this.Year);
    for (let i = 1; i <= 12; i++) {
      _self.MonthOptions.push({text: i, value: i});
    }
    for (let i = -3; i <= 3; i++) {
      _self.YearOptions.push({text: (new Date()).getFullYear() + i, value: (new Date()).getFullYear() + i});
    }
  }
  getWeeksOfYear(year: number) {
    const d = new Date();
    d.setFullYear(year, 12, 31);
    return this.getWeek(d);
  }
  getWeek(d: Date) {
    const date = new Date(d.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    const week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
      - 3 + (week1.getDay() + 6) % 7) / 7);
  }

  getCalDayClass(c) {
    const cls = [];
    if (c.calIsOdd) {
      cls.push('is-odd');
    }
    if (c.calIsHoliday) {
      cls.push('is-holiday-full');
    }

    if (c.calIsPartialHoliday) {
      cls.push('is-holiday-part');
    }

    if (c.calIsToday) {
      cls.push('is-today');
    }
    return cls;
  }

  ngOnInit() {
    this.initalLoad();
  }

  handleKeyPress(event) {
    if (event.code === 'Enter') {
      this.reload();
    }
  }
  raiseChange() {
    const _self = this;
    this.reload();
  }


  initalLoad() {
    const _self = this;
    _self.isLoading = true;
    let url = '';
    if (_self.WeekMode) {
      url = _self.excRest.computeUrl('CalendarWeekR_Summary', {Year: this.Year, Week: this.IsoWeek, Country: 'de', fts: (_self.SearchValue === '' ? null : _self.SearchValue)});
    } else {
      url = _self.excRest.computeUrl('CalendarR_Summary', {Year: this.Year, Month: this.Month, Country: 'de', fts: (_self.SearchValue === '' ? null : _self.SearchValue)});
    }
    _self.excRest.get(url, {}).subscribe(ret => {
      if (ret) {
        _self.Calendar = ret.data.Calendar;
        _self.WeekList = ret.data.Weeks;
        for (const x of _self.WeekList) {
          if (x.Year === _self.Year) {
            _self.WeeksOfYear = x.Weeks;
            _self.WeekOptions = [];
            for (let i = 1; i <= _self.WeeksOfYear; i++) {
              _self.WeekOptions.push({text: _self.getGlobal('WeekOfYear') + ' ' + i, value: i});
            }
            break;
          }
        }
        for (const c of _self.Calendar) {
          c['Audits'] = [];
          for (const a of ret.data.Items) {
            if (c.Idx === a.Idx) {
              c['Audits'] = a['Audits'];
            }
          }
        }
      }
      _self.isLoading = false;
    });
  }
  reload() {
    const _self = this;
    let url = '';
    if (_self.WeekMode) {
      url = _self.excRest.computeUrl('CalendarWeekR_List', {
        Year: this.Year,
        Week: this.IsoWeek,
        Country: 'de',
        fts: (_self.SearchValue === '' ? null : _self.SearchValue)
      });
    } else {
      url = _self.excRest.computeUrl('CalendarR_List', {
        Year: this.Year,
        Month: this.Month,
        Country: 'de',
        fts: (_self.SearchValue === '' ? null : _self.SearchValue)
      });
    }
    _self.excRest.get(url, {}).subscribe(ret => {
      if (ret) {
        for (const c of _self.Calendar) {
          c['Audits'] = [];
          for (const a of ret.data.Items) {
            if (c.Idx === a.Idx) {
              c['Audits'] = a['Audits'];
            }
          }
        }
      }
    });
  }

  setMonth(delta) {
    if (this.WeekMode) {
      const tmpWeek = this.IsoWeek + delta;
       if (tmpWeek === 0) {
         const tmpYear = this.Year - 1;
         for (const x of this.WeekList) {
           if (x.Year === tmpYear) {
             this.Year = tmpYear;
             this.IsoWeek =  x.Weeks;
           }
         }
       } else if (tmpWeek > this.WeekOptions.length + 1) {
         const tmpYear = this.Year + 1;
         for (const x of this.WeekList) {
           if (x.Year === tmpYear) {
             this.Year = tmpYear;
             this.IsoWeek =  1;
           }
         }
       } else {
         this.IsoWeek = tmpWeek;
       }
    } else {
      this.Month = this.Month + delta;
      if (this.Month === 0) {
        this.Month = 12;
        this.Year = this.Year - 1;
      } else if (this.Month === 13) {
        this.Month = 1;
        this.Year = this.Year + 1;
      }
    }
    this.initalLoad();
  }
  handleSelectMonth(e) {
    this.Month = Number((<HTMLSelectElement>e.target).selectedOptions[0].value);
    this.initalLoad();
  }
  handleSelectWeek(e) {
    this.IsoWeek = Number((<HTMLSelectElement>e.target).selectedIndex + 1);
    this.initalLoad();
  }
  handleSelectYear(e) {
    this.Year = Number((<HTMLSelectElement>e.target).selectedOptions[0].value);
    this.WeeksOfYear = this.getWeeksOfYear(this.Year);
    this.initalLoad();
  }
  toggleMode() {
    this.SmallMode = !this.SmallMode;
  }
  toggleWeekMode() {
    this.WeekMode = !this.WeekMode;
    this.initalLoad();
  }
  openAudit(a) {
    new ExcTab(a['DealerName'] + ' - ' + a.AuditID, AuditDetailsComponent, a, a.AuditID, {
      Unique: true, ReloadParent: function () {
        // _self.initialLoad();
      }
    }, true).Open();
  }
  getIconClass(a) {
    let cls = '';

    switch (a.AuditType) {
      case 16:
        cls += 'fa-mobile';
        break;
      case 30:
      case 31:
      case 32:
        cls += 'fa-sack-dollar';
        break;
      case 33:
        cls += 'fa-video';
        break;
      case 34:
        cls += 'fa-satellite';
        break;
      case 35:
        cls += 'fa-scanner-image';
        break;
      default:
        cls += 'fa-user-secret';
        break;
    }
    if (a.AuditIsPicked === true) {
      cls = cls + ' th-warning';
    } else {
      cls = cls + ' th-secondary';
    }
    return cls;
  }
  getTooltip(a) {
    let t = this.getGlobal('AuditType_' + a.AuditType);
    // switch (a.AuditType) {
    //   case 16:
    //     t = this.getGlobal('Selfcheck');
    //     break;
    //   case 30:
    //   case 31:
    //   case 32:
    //     t = this.getGlobal('Pauschalkredit');
    //     break;
    //   case 33:
    //     t = this.getGlobal('Videocheck');
    //     break;
    //   case 34:
    //     t = this.getGlobal('Geofence');
    //     break;
    //   case 34:
    //     t = this.getGlobal('Geofence');
    //     break;
    //   default:
    //     t = this.getGlobal('Floorcheck');
    //     break;
    // }
    t += ' - ';
    if (a.AuditType === 16 || a.AuditType === 35) {
      switch (a.AuditStatus) {
        case 1:
        case 2:
        case 3:
          t += this.getGlobal('Planned');
          break;
        case 8:
        case 9:
          if (a.Rejected === true) {
            t += this.getGlobal('Rejected');
          } else {
            if (a.Expired === false) {
              t += this.getGlobal('Done');
            } else {
              t += this.getGlobal('Expired');
            }
          }
        break;
        case 10:
          t += this.getGlobal('Cancelled');
          break;
      }
    } else {
      switch (a.AuditStatus) {
        case 1:
          t += this.getGlobal('Created');
          break;
        case 2:
          t += this.getGlobal('Assigned');
          break;
        case 3:
          t += this.getGlobal('Planned');
          break;
        case 4:
        case 5:
        case 6:
        case 7:
          t += this.getGlobal('InProgress');
          break;
        case 8:
        case 9:
          t += this.getGlobal('Done');
          break;
        case 10:
          t += this.getGlobal('Cancelled');
          break;
      }
    }
    t += '\r\n\r\n';
    t += this.excDss.getLabel('DealerLevel1') + ': ' + a.DealerLevel1 + '\r\n';
    if (a.DealerLevel2 !== null && a.DealerLevel2 !== '') {
      t += this.excDss.getLabel('DealerLevel2') + ': ' + a.DealerLevel2 + '\r\n\r\n';
    }
    if (a.DealerLevel2 !== null && a.DealerLevel3 !== '') {
      t += this.excDss.getLabel('DealerLevel3') + ': ' + a.DealerLevel3 + '\r\n\r\n';
    }
    t += a.DealerName + '\r\n';
    t += a.DealerCountry + '-' + a.DealerZip + ' ' + a.DealerCity;
    return t;
  }
  getIconHostClass(a) {
    let cls = '';

    if (a.AuditType === 16) {
      cls = 'sc ';
    } else {
      cls = 'fc ';
    }

    switch (a.AuditStatus) {
      case 1:
      case 2:
      case 3:
        cls = cls + ' planned';
        break;
      case 4:
      case 5:
      case 6:
      case 7:
        cls = cls + ' in-progress';
        break;
      case 8:
      case 9:
        if (a.AuditType === 16) {
          if (a.Rejected === true) {
            cls += ' rejected';
          } else if (a.Expired === true) {
            cls += ' expired';
          } else {
            cls += ' done';
          }
        } else {
          cls += ' done';
        }
        break;
      case 10:
        cls = cls + ' cancelled';

    }
    return cls;

  }
  getAttractorTip(a) {
    if (a.AuditType === 16) {
      switch (a.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
        case 8:
        case 9:
          if (a.ScRejected === true) {
            return this.getGlobal('Rejected');
          } else {
            if (a.ScEnded === true) {
              return this.getGlobal('Done');
            } else {
              return this.getGlobal('Expired');
            }
          }
        case 10:
          return this.getGlobal('Cancelled');
      }
    } else {
      switch (a.AuditStatus) {
        case 1:
          return this.getGlobal('Created');
        case 2:
          return this.getGlobal('Assigned');
        case 3:
          return this.getGlobal('Planned');
        case 4:
        case 5:
        case 6:
        case 7:
          return this.getGlobal('InProgress');
        case 8:
        case 9:
          return this.getGlobal('Done');
        case 10:
          return this.getGlobal('Cancelled');
      }
    }
  }
  getAttractorClass(a) {
    if (a.AuditType === 16) {
      switch (a.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
        case 8:
        case 9:
          if (a.ScRejected === true) {
            return 'ch-danger fa-exclamation';
          } else {
            if (a.ScEnded === true) {
              return 'ch-success fa-check';
            } else {
              return 'ch-warning fa-clock';
            }
          }
        case 10:
          return 'ch-warning fa-ban';
      }
    } else {
      switch (a.AuditStatus) {
        case 1:
          return 'ch-secondary fa-asterisk';
        case 2:
          return 'ch-secondary fa-user';
        case 3:
          return 'ch-secondary fa-calendar';
        case 4:
        case 5:
        case 6:
        case 7:
          return 'ch-secondary fa-cogs';
        case 8:
        case 9:
          return 'ch-success fa-check';
        case 10:
          return 'ch-warning fa-ban';
      }
    }
  }

}
